import {
  CheckBadgeIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/solid";
import ToastComp from "../Toasts";
import toast from "react-hot-toast";

function handleSuccessToast({
  message,
  duration = 2000,
}: {
  message: string;
  duration?: number;
}) {
  return toast(
    (t) => (
      <ToastComp
        toastContent={t}
        message={message}
        icon={<CheckBadgeIcon className="size-5 text-success" />}
      />
    ),
    {
      duration,
    }
  );
}

function handleErrorToast({
  message,
  duration = 2000,
}: {
  message: string;
  duration?: number;
}) {
  return toast(
    (t) => (
      <ToastComp
        toastContent={t}
        message={message}
        icon={<ExclamationCircleIcon className="size-5 text-error" />}
      />
    ),
    {
      duration,
    }
  );
}

function handleNetworkError(
  error: { response: any; message: string } extends Error ? any : any
) {
  const message = error?.response.data.message || "Internal Server Error!";
  handleErrorToast({ message });
}

export { handleErrorToast, handleSuccessToast, handleNetworkError };
